import Vue, { CreateElement } from 'vue'
import { createComponent, ref, createElement, Ref } from '@vue/composition-api'
import { openNewRenew } from '@/components/new_renew/new_renew.tsx'
const vueInstance = new Vue()

type MessageType = "error" | "success" | "info" | "warning" | undefined

export function openMessage(type: MessageType, message: string, options: {
    duration?: number
} = {
    duration: 2000
}) {
    vueInstance.$message({
        type,
        message,
        showClose: true,
        duration: options.duration
    })
}

export function openRenewMessage(message: string, options: {
    duration?: number
} = {
    duration: 2000
}) {
    const h = vueInstance.$createElement    // 不能删除
    vueInstance.$message({
        type: 'error',
        message: (
            <div class="fs-14 fx-v-center fx-h-between mr-30" style="white-space: nowrap">
                <span class="mr-6 lh-20 color-red">{ message }</span>
                <span class="href fx-v-center" style="flex: none" onClick={ () => {
                    openMessage('info', '请前往零售通客户端操作')
                    // openNewRenew()
                } }>立即升级>></span>
            </div>
        ),
        showClose: true,
        duration: options.duration
    })
}

const createWaringDialog = function(options: {
    title?: string,
    type?: 'danger' | 'primary',
    message?: string,
    render?: (h: CreateElement) => JSX.Element,
    confirmBtnText?: string,
    cancelBtnText?: string,
    isDisabled?: Ref<boolean>
    isShowFooter?: boolean,
    width?: string
}) {
    options = Object.assign({
        type: 'primary',
        title: '提示',
        confirmBtnText: '确认',
        cancelBtnText: '取消',
        isDisabled: ref(false),
        isShowFooter: true,
        width: '400px'
    }, options)
    return new Vue<{
        dialogVisible: boolean
    }, {
        open: () => void
        close: () => void
        cancel: () => void
        confirm: () => void
    }>({
        setup(props, ctx) {
            const dialogVisible = ref(false)

            function open() {
                dialogVisible.value = true
            }

            function close() {
                ctx.emit('cancel')
                dialogVisible.value = false
            }

            function cancel() {
                ctx.emit('cancel')
                dialogVisible.value = false
            }

            function confirm() {
                ctx.emit('confirm')
                dialogVisible.value = false
            }

            return {
                cancel,
                confirm,
                open,
                close,
                dialogVisible
            }
        },

        render(h) {
            // const h = createElement // 不能删除
            return <dialog-template
                    headerTitle={options.title}
                    visible={this.dialogVisible}
                    onClose={this.close}
                    append-to-body={true}
                    destroy-on-close={true}
                    width={ options.width }
                >
                {options.message && <div>{options.message}</div>}
                {options.render && options.render(h)}
                { options.isShowFooter && (
                    <div slot="footer" style="text-align: center">
                        <el-button size="medium" onClick={this.confirm} type={options.type} disabled={ (options.isDisabled as Ref<boolean>).value }>
                            {options.confirmBtnText}
                        </el-button>
                        <el-button size="medium" onClick={this.cancel} plain>{options.cancelBtnText}</el-button>
                    </div>
                )}
            </dialog-template>
        }
    })
}

export function openWarning(options: {
    title?: string,
    type?: 'danger' | 'primary',
    message?: string,
    render?: (h: CreateElement) => JSX.Element,
    confirmBtnText?: string,
    cancelBtnText?: string,
    isDisabled?: Ref<boolean>
    isShowFooter?: boolean,
    width?: string
}): Promise<any> {
    const dialogInstance = createWaringDialog(options)
    dialogInstance.$mount()
    document.body.appendChild(dialogInstance.$el)
    dialogInstance.open()
    return new Promise((resolve, reject) => {
        dialogInstance.$on('confirm', resolve)
        dialogInstance.$on('cancel', reject)
    }).finally(() => {
        setTimeout(() => {
            if (document.body.contains(dialogInstance.$el)) {
                document.body.removeChild(dialogInstance.$el)
                dialogInstance.$destroy()
            }
        }, 300)
    })
}

type ScrollListenCallback = (event: {
    direction: 'up' | 'down',
    scrollTop: number,
    scrollLeft: number,
    distanceRelativeToBottom: number
}) => void

export function scrollLoadListen(options: {
    dom: Element,
    callback: ScrollListenCallback
}) {
    let lastPotion = 0
    const dom: any = options.dom

    if ('onmousewheel' in dom) {
        console.log('onmousewheel')
        dom.addEventListener('mousewheel', e => scrollFn(e.wheelDelta))
    } else {
        console.log('DOMMouseScroll')
        dom.addEventListener('DOMMouseScroll', e => scrollFn(-e.detail))
    }

    dom.addEventListener('scroll', () => scrollFn(-1))

    function scrollFn(delta: number) {
        const distanceRelativeToBottom = dom.scrollHeight - dom.scrollTop - dom.clientHeight
        const direction = getDirection(lastPotion, dom.scrollTop, delta)
        lastPotion = dom.scrollTop
        options.callback({
            direction,
            distanceRelativeToBottom,
            scrollTop: dom.scrollTop,
            scrollLeft: dom.scrollLeft
        })
    }

    function getDirection(last, now, direction) {
        return (now - last >= 0 && direction < 0) ? 'down' : 'up'
    }
}

type ScrollLoadFunction = (page: number) => Promise<{
    pagination: {
        page: number,
        page_count: number,
        limit: number
    }
}>

export function useScrollLoad(mainOptions = {
    isUseLimit: false,
    dataKey: ''
}) {
    const page = ref(1)
    const isHasMore = ref(true)
    const isLoading = ref(false)
    const eventTarget = ref<any>({})

    function bindListener(options: {
        dom: Element,
        loadFunction: ScrollLoadFunction
    }) {
        scrollLoadListen({
            dom: options.dom,
            callback: (event) => {
                eventTarget.value = event
                if (event.direction === 'down' && event.distanceRelativeToBottom < 60 && isHasMore.value && !isLoading.value) {
                    isLoading.value = true
                    options.loadFunction(page.value + 1).then(data => {
                        // catch之后也会走then
                        if (!data) {
                            return
                        }
                        page.value = data.pagination.page
                        if (mainOptions.isUseLimit) {
                            isHasMore.value = data[mainOptions.dataKey].length === data.pagination.limit
                        } else {
                            isHasMore.value = data.pagination.page_count > page.value
                        }
                    }).finally(() => {
                        isLoading.value = false
                    })
                }
            }
        })
    }

    function initScrollLoad(data: {
        pagination: {
            page: number,
            page_count: number,
            limit: number
        }
    }) {
        if (!data.pagination) {
            return
        }
        if (mainOptions.isUseLimit) {
            isHasMore.value = data[mainOptions.dataKey].length === data.pagination.limit
        } else {
            isHasMore.value = data.pagination.page_count > page.value
        }
    }

    function getCurEvent() {
        return eventTarget.value
    }

    function initScrollState(options: {
        page?: number
        isHasMore?: boolean
        isLoading?: boolean
        eventTarget?: object
    } = {}) {
        const newOptions = Object.assign({
            page: 1,
            isHasMore: true,
            isLoading: false,
            eventTarget: {}
        }, options)
        page.value = newOptions.page
        isHasMore.value = newOptions.isHasMore
        isLoading.value = newOptions.isLoading
        eventTarget.value = newOptions.eventTarget
    }

    return {
        eventTarget,
        page,
        isHasMore,
        isLoading,
        bindListener,
        initScrollLoad,
        getCurEvent,
        initScrollState
    }
}
